import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const RegimenFiscalRedux = createActions(
  {
  },
  {
    prefix: 'REGIMEN_FISCAL',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = RegimenFiscalRedux
export const RegimenFiscalTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})


export const reducer = createReducer(
  INITIAL_STATE, {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/RegimenFiscalRedux.js